<div class="inner-mat-dialog flex justify-start content-stretch items-stretch flex-col">
   
    <div>
      <h1 mat-dialog-title id="addnewsite" style="margin: 0px 1px 13px 1px; ">
        <div class="flex justify-start content-center items-center flex-row">
          <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
            Group Canisters
          </div>
        
          <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
            <mat-icon (click)="closeWizard.emit(true)" class="cross-wizard">
              <img src="/assets/img/icons/ico.16.clear.svg" alt="">
            </mat-icon>
          </div>
    
        </div>
    
      </h1>
  
  
      <mat-dialog-content>
        <table mat-table [dataSource]="dataSourceGroupCanister" multiTemplateDataRows class="mat-elevation-z8 main-table">
          <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef width="10%"> </th>
            <td mat-cell *matCellDef="let element" width="10%"><span style="font-weight: bold;">
                <mat-checkbox [(ngModel)]="element.isChecked" 
                  (change)="groupCanisterRowSelect(element, $event.checked); element.isExpanded = !element.isExpanded;"></mat-checkbox>
                <span *ngIf="element.isExpanded">
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.16.arwup.svg" alt="">
                  </mat-icon>
                </span>
                <span *ngIf="!element.isExpanded">
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.16.arwdown.svg" alt="">
                  </mat-icon>
                </span>
              </span> </td>
          </ng-container>
          <!-- Checkbox Column -->
          <!-- <ng-container matColumnDef="checkbox">
                      <th mat-header-cell *matHeaderCellDef>
  
                      </th>
                      <td mat-cell *matCellDef="let element">
                          <mat-checkbox [(ngModel)]="element.isChecked" (change)="groupCanisterRowSelect(element, $event.checked)" ></mat-checkbox>
                      </td>
                  </ng-container> -->
  
          <!--  Top Order Column -->
          <ng-container matColumnDef="topOrder">
            <th mat-header-cell *matHeaderCellDef> Top Order </th>
            <td mat-cell *matCellDef="let element"> {{element?.topOrder}} </td>
          </ng-container>
          <!--  Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element?.customerDrugName}} </td>
          </ng-container>
          <!--  Strength Column -->
          <ng-container matColumnDef="strength">
            <th mat-header-cell *matHeaderCellDef> Strength </th>
            <td mat-cell *matCellDef="let element"> {{element?.strength}} </td>
          </ng-container>
          <!-- NDC Column -->
          <ng-container matColumnDef="ndc">
            <th mat-header-cell *matHeaderCellDef> NDC </th>
            <td mat-cell *matCellDef="let element"> {{element?.ndc}} </td>
          </ng-container>
  
          <!-- Usage Column -->
          <ng-container matColumnDef="usage">
            <th mat-header-cell *matHeaderCellDef> Usage </th>
            <td mat-cell *matCellDef="let element"> {{element?.usage}} </td>
          </ng-container>
  
  
          <!-- Group Canister Column -->
          <ng-container matColumnDef="groupCanister">
            <th mat-header-cell *matHeaderCellDef>Canisters Assigned</th>
            <td mat-cell *matCellDef="let element">
              <input class="custom-input" 
                (change)="updateSelectedGroupCanisterList(element); element.groupCanister = element.groupCanister > 20 ? 0 : element.groupCanister" 
                [disabled]="true" type="number" [(ngModel)]="element.groupCanister">
            </td>
          </ng-container>
          <!-- hcgroupcanister Column -->
          <ng-container matColumnDef="highCapGroupCanister">
            <th mat-header-cell *matHeaderCellDef>HC Canisters Assigned</th>
            <td mat-cell *matCellDef="let element">
              <input class="custom-input" type="number" 
                (change)="updateSelectedGroupCanisterList(element); element.highCapGroupCanister = element.highCapGroupCanister > 20 ? 0 : element.highCapGroupCanister" 
                [disabled]="true" [(ngModel)]="element.highCapGroupCanister">
            </td>
          </ng-container>
  
          <!-- bottleQty Column -->
          <ng-container matColumnDef="bottleQty">
            <th mat-header-cell *matHeaderCellDef>Stock Bottle Size</th>
            <td mat-cell *matCellDef="let element">
              {{element.bottleQty}}</td>
          </ng-container>
          <!-- maxCap Column -->
          <ng-container matColumnDef="maxCap">
            <th mat-header-cell *matHeaderCellDef>Canister Capacity</th>
            <td mat-cell *matCellDef="let element">
              {{element.maxCap}}</td>
          </ng-container>
  
          <!-- hccMaxCap Column -->
          <ng-container matColumnDef="hccMaxCap">
            <th mat-header-cell *matHeaderCellDef>HC Canister Capacity</th>
            <td mat-cell *matCellDef="let element">
              {{element.hccMaxCap}}</td>
          </ng-container>
  
          <!-- daysOfPillQtyReq Column -->
          <ng-container matColumnDef="daysOfPillQtyReq">
            <th mat-header-cell *matHeaderCellDef>Days Of Use Pill Qty Req</th>
            <td mat-cell *matCellDef="let element">
              {{element.daysOfPillQtyReq}}</td>
          </ng-container>
  
          <!-- recCanister Column -->
          <ng-container matColumnDef="recCanister">
            <th mat-header-cell *matHeaderCellDef>Recomended Canisters</th>
            <td mat-cell *matCellDef="let element">
              {{element.recCanister}}</td>
          </ng-container>
  
          <!-- recHcCanister Column -->
          <ng-container matColumnDef="recHcCanister">
            <th mat-header-cell *matHeaderCellDef>Recomended HC Canisters</th>
            <td mat-cell *matCellDef="let element">
              {{element.recHcCanister}}</td>
          </ng-container>
          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" style="padding:0px" 
              [attr.colspan]="displayedColumnsGroupCanister.length">
              <div class="row queue-element-detail" [@detailExpand]="(element.isExpanded) ? 'expanded' : 'collapsed'">
                <div class="flex justify-start content-between items-between flex-row">
                  <div class="device-cell flex flex-col">
                    <table>
                      <tr>
                        <th colspan="4">
                          ATP - Device
                        </th>
                      </tr>
                      <tr *ngFor="let row of atpTableData">
                        <td [id]="'drawer-'+element.ndc+'-'+cell" (click)=" showhideElement(element.ndc, cell, $event)" 
                          *ngFor="let cell of row">{{ cell }}</td>
                      </tr>
                    </table>
                  </div>
                  <div *ngFor="let drawer of deviceDrawer" class="device-design" style="display:none" 
                    [id]="element.ndc+'-'+drawer.drawerNumber">
                    <p [id]="'highcaplevel-'+element.ndc+'-'+drawer.drawerNumber" style="display:none">High Cap</p>
                    <p [id]="'smartdrawerlevel-'+element.ndc+'-'+drawer.drawerNumber" style="display:none;color:red">Smart</p>
                    
                    <table>
                      <tr *ngFor="let row of drawer.drawerCell">
                        <td [id]="'drawercell-'+element.ndc+'-'+drawer.drawerNumber+'-'+cell" 
                          (click)="selectDrawerCell(drawer.drawerNumber,element.ndc, cell, $event )" 
                          *ngFor="let cell of row">{{ cell }}</td>
                      </tr>
                    </table>
                    <span [id]="'drawerlevel-'+element.ndc+'-'+drawer.drawerNumber">{{drawer.drawerName}}</span>
                  </div>
  
                </div>
              </div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumnsGroupCanister; sticky: true"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumnsGroupCanister;" class="queue-element-row" 
            [class.queue-expanded-row]="element.isExpanded">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="queue-detail-row"></tr>
  
  
        </table>
        <table class="no-result" *ngIf="dataSourceGroupCanister.data.length==0">
          <tr style="text-align: center;">
            <td [attr.colspan]="displayedColumnsGroupCanister.length">
              <span>No results found</span>
            </td>
          </tr>
  
        </table>
  
  
      </mat-dialog-content>
    </div>
    <mat-dialog-actions class="flex flex-row justify-end content-end items-end w-full">
      <button mat-button class="btn-primary btn-md" (click)="openAlertWindowForGroupCanisterBackButton()" id="Go_Back" 
        type="button" aria-label="Go_Back">Go Back</button>
      <button mat-button class="btn-blue btn-md" (click)="saveGroupCanister()" id="Import" type="button" 
        aria-label="Import">Import</button>
    </mat-dialog-actions>
  

</div>